import groq from 'groq';

import { ASSET, RICH_TEXT } from '../common';

export const LISTICLE_ITEM = groq`
  title,
  description[] {
    ${RICH_TEXT}
  },
  image { ${ASSET} }
`;

export const LISTICLE_ITEM_BLOCK = groq`
  _type == 'listicleItem' => {
    ${LISTICLE_ITEM}
  }
`;
